import { t } from 'i18next'
import { Avatar } from 'primereact/avatar'
import { Card } from 'primereact/card'
import React, { Fragment } from 'react'
import { SalutationCt, UserAccountType } from '../../../../model/enums/enums'
import { Apprentice, Person } from '../../../../model/person.model'
import { useAppSelector } from '../../../../redux/hooks'
import { getUserAvatarSrc } from '../../../../util/getAvatar'
import { getPersonName } from '../../../../util/getPersonName'
import { getUserAccountTitleString } from '../../../../util/getUserAccountTitleString'
import { ContactBody } from '../../../util/data-table/cell-body/ContactBody'

export const BusinessCard = (props: {
  person: Apprentice | Person | undefined
  companyName: string | undefined
}): JSX.Element => {
  const professions = useAppSelector((state) => state.professions)
  const activeLanguage = localStorage.getItem('i18nextLng')
  const cardProfession = (): JSX.Element => {
    if (!props.person?.user_account_type) {
      return <></>
    }
    if (props?.person?.user_account_type !== UserAccountType.Apprentice) {
      return <></>
    }
    const person = props.person as Apprentice
    const professionId = person.apprentice?.id_profession
    const specialityId = person.apprentice?.id_speciality

    if (!professionId) {
      return <></>
    }
    let professionString = ''
    let profession = professions.find((p) => p.profession_id === professionId)
    if (profession) {
      professionString =
        activeLanguage !== 'de'
          ? t(`profession.${profession.profession_id}`)
          : profession.profession
    }

    let specialityString = ''

    if (specialityId) {
      const spec = professions
        .find((p) => p.profession_id === professionId)
        ?.specialities?.find((s) => s.speciality_id === specialityId)
      if (spec) {
        specialityString = ` (${
          activeLanguage !== 'de'
            ? t(`profession.speciality.${spec.speciality_id}`)
            : spec.speciality_name
        })`
      }
    }

    return (
      <span>
        {professionString}
        {specialityString}
      </span>
    )
  }

  const employeeRole = (): JSX.Element => {
    const accountType = props.person?.user_account_type
    const salutation = props.person?.salutation
    return <span>{getUserAccountTitleString(accountType, salutation)}</span>
  }

  const cardDetail = (): JSX.Element => {
    if (props.person?.user_account_type === UserAccountType.Apprentice) {
      return cardProfession()
    }
    return employeeRole()
  }

  const cardRole = (): string => {
    const gender = props.person?.salutation
    const accountType = props.person?.user_account_type
    const companyName = props.companyName ? props.companyName + ' - ' : ''
    if (accountType === UserAccountType.Apprentice) {
      if (gender === SalutationCt.Ms) {
        return companyName + t<string>('core.apprentice.female')
      }
      if (gender === SalutationCt.Mr) {
        return companyName + t<string>('core.apprentice.male')
      }
      return companyName + t<string>('core.apprentice.neutral')
    } else {
      if (gender === SalutationCt.Ms) {
        return companyName + t<string>('core.employee.female')
      }
      if (gender === SalutationCt.Mr) {
        return companyName + t<string>('core.employee.male')
      }
      return companyName + t<string>('core.employee.neutral')
    }
  }

  return (
    <Fragment>
      <Card
        key={props.person?.person_id}
        className={`business-card business-card-width ${
          props.person?.user_account_type === UserAccountType.Apprentice
            ? 'background-banner-apprentice'
            : 'background-banner-employee'
        }`}
      >
        <span>
          <Avatar
            image={getUserAvatarSrc(props.person)}
            shape="circle"
            className={'avatar business-avatar'}
          />
        </span>
        <div className="business-card-social-links">
          <ContactBody
            email={props.person?.email}
            slackUserId={props.person?.slack_user_id}
            companyId={props.person?.id_company}
          />
        </div>
        <span className="card-role">{cardRole()}</span>
        <span className="name-prof">
          <span className="business-card-text">
            {getPersonName(props.person)}
          </span>
          <span className="secondary-text block-display card-profession">
            {cardDetail()}
          </span>
        </span>
      </Card>
    </Fragment>
  )
}